module.exports = __webpack_public_path__ + "img/customer.9bcee299.png";